
export const SCHEDULE_TYPES = [
    { id: "TEAM_PRACTICE", scheduleName: "Team Practice" },
    { id: "MEET", scheduleName: "Meet" },
    { id: "MEETING", scheduleName: "General Meeting" }
];
export const MEETING_MODE = [
    { id: "OFFLINE", mode: "Offline" },
    { id: "ONLINE", mode: "Online" }
];
export const MEETING_PLATFORM = [
    { id: "GOOGLE_MEET", platform: "Google Meet" },
    { id: "ZOOM", platform: "Zoom" }
];
